import type { CoreElement } from '@tunasong/schemas'

export const baseElementTemplate: Pick<CoreElement, 'children'> = {
  children: [{ text: '' }],
}

export const entityTemplate = {
  children: [{ type: 'line', children: [{ text: '' }] }],
}
